import React, { createElement } from 'react';
import { render } from 'react-dom';
import './index.css';
import { App } from './App';
// Preconnect to external origins for faster resource loading
const origins = ['https://cdn.magicpatterns.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'];
origins.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (href.includes('gstatic')) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
// Load Google Fonts via <link> instead of CSS @import (non-render-blocking)
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap';
fontLink.media = 'print';
fontLink.onload = function () {
  ;
  (this as HTMLLinkElement).media = 'all';
};
document.head.appendChild(fontLink);
// Preload hero image for faster LCP
const heroPreload = document.createElement('link');
heroPreload.rel = 'preload';
heroPreload.as = 'image';
heroPreload.href = 'https://cdn.magicpatterns.com/uploads/rN2CiMksSwRM2LVZfGn2Pe/heylloyd-image-1773372626707.png';
document.head.appendChild(heroPreload);
render(<App data-id="element-4" />, document.getElementById('root'));